import ProductJSON from "./product-json";
const ProductShrinkBands = () => {
    let _this = {
        variant: false,
        accepted  : false,
        containerQuantity : 0,
        quantity : 0,
    }
    const { productMeta , productData} = ProductJSON();
    
    _this.init = function(){
        _this.container = document.querySelector('[product-shrink-bands]'),
        _this.form  = _this.container.querySelector('[product-shirnk-bands-form]');
        const radios = _this.container.querySelectorAll( 'input[type="radio"]' );
        radios.forEach( radio => {
            radio.addEventListener( 'change' , function( $event ){
                _this.accepted = radio.value == 'yes' ? true : false;
                _this.updateForm();
                document.dispatchEvent(new CustomEvent( 'productShrinkBands.acceptChange' , { detail : _this }  ) );
            });
        });
    }

    /**
     * Get the shrink bands from the Filter API 
     */
    _this.get = async function(){
        _this.data = await fetch( '/collections/all/?view=shrink-band-search&filter.p.product_type=Closure&filter.p.tag=Shrink+Bands' )
        .then( response => response.json() )
    }

    /**
     * Get the shrink band variant based on the current variant and factors
    **/

    _this.validate = function( currentVariant, currentVariantMeta  , productOptions , selectedClosure , quantity ){
        const shrinkBandSku = currentVariantMeta.shrink_band_sku;
        let excludeShrinkBand = productMeta.exclude_shrink_band == true ? true : false ;
        _this.variant = false;
        _this.containerQuantity = quantity;
        _this.currentVariant = currentVariant;
        // check if closure is excluding shrink bands
        if( selectedClosure && !excludeShrinkBand && shrinkBandSku){
            excludeShrinkBand = selectedClosure.excludeShrinkBand == 'true';
            if( !excludeShrinkBand ){
                _this.data.forEach( shrinkBand => {
                    const match = shrinkBand.variants.find( variant => {
                        return variant.sku == shrinkBandSku
                    });
                    if( typeof( match ) !== 'undefined'){
                        _this.variant = match
                    }
                })
            }
        }

        _this.updateView();
        _this.updateForm();
    }

    /**
     * Update the view with the shrink band variant or hide it
     */
    _this.updateView = function(){
        if( _this.variant ){
            _this.container.classList.remove('d-none');
        }else{
            _this.container.classList.add('d-none');
        }
    }

    _this.updateForm = function(){
        _this.quantity = Math.ceil( _this.containerQuantity / 250 ) * 250;

        if( _this.variant && _this.accepted ){
            _this.form.innerHTML = `
                <input type="hidden" name="items[2]id" value="${_this.variant.id}">
                <input type="hidden" name="items[2]quantity" value="${_this.quantity}">
                <input type="hidden" product-closure-selected-quantity name="items[2]properties[_bundle_parent]" value="${_this.currentVariant.id}">
            `
        }else{
            _this.form.innerHTML = ``
        }
    }

    _this.init();
    return _this;
}

export default ProductShrinkBands